import { ApisauceInstance } from 'apisauce'
import { PaginationResponse } from '@codeleap/query'
import { Profile, ProfileApp, ProfileFeatures, ProfileListUsersFilters, ProfilePhoto } from './types'

const LOCAL = false // Set to true for local development, false for production
const LOCAL_URL = 'http://localhost:8000/'

export class ProfileAPI {
  protected api: ApisauceInstance
  protected LOCAL: boolean

  constructor(api: ApisauceInstance) {
    this.api = api
  }

  private getOptions(options?: object) {
    if (LOCAL) {
      return { ...(options || {}), baseURL: LOCAL_URL }
    }
    return options || {}
  }

  async list(filters?: ProfileListUsersFilters) {
    const response = await this.api.get<PaginationResponse<Profile>>(
      'profiles/',
      {
        ...filters,
        limit: 40
      },
      this.getOptions()
    )
    return response
  }

  async resetPassword(email: string) {
    const response = await this.api.get(
      'profiles/reset_password/',
      { email },
      this.getOptions()
    )
    return response
  }

  async retrieve({ id }: { id: string }) {
    const response = await this.api.get<Profile>(
      `profiles/${id}/`,
      {},
      this.getOptions()
    )
    return response
  }

  async updateAvatar(
    avatarUrl: File
  ) {
    const response = await this.api.post<ProfilePhoto>(
      `profiles/photos/`,
      { file: avatarUrl },
      {
        ... this.getOptions(),
        // @ts-ignore
        multipart: true,
      }
    )
    return response
  }

  async removeAvatar() {
    const response = await this.api.delete(
      `profiles/remove_avatar/`,
      {},
      this.getOptions()
    )
    return response
  }

  async listFeatures() {
    const response = await this.api.get<ProfileFeatures[]>('profiles/features/', undefined, this.getOptions())
    return response
  }

  async listApps() {
    try {
      const response = await this.api.get<ProfileApp[]>('profiles/apps/', undefined, this.getOptions())
      return response
    } catch (error) {
      console.error('Failed to list apps', error)
      return null 
    }
  }
}
